module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Ortung.286a0d57.svg";